import { render, staticRenderFns } from "./recordCertificateP.vue?vue&type=template&id=6deb4dbb&scoped=true"
import script from "./recordCertificateP.vue?vue&type=script&lang=js"
export * from "./recordCertificateP.vue?vue&type=script&lang=js"
import style0 from "./recordCertificateP.vue?vue&type=style&index=0&id=6deb4dbb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb4dbb",
  null
  
)

export default component.exports